if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      let rawContent = this.innerHTML;
      let titleFlag = false;
      
      rawContent = rawContent.replace(/&lt;br\s*\/?&gt;/gi, '\n');
      rawContent = rawContent.replace(/&lt;br&gt;/gi, '\n');
      rawContent = rawContent.replace(/<br\s*\/?>/gi, '\n');
      
      const tempEl = document.createElement('div');
      tempEl.innerHTML = rawContent;
      let content = tempEl.textContent || tempEl.innerText || rawContent;
      
      let initialLines = content.split(/\n/);
      let allLines = [];
      
      for (let i = 0; i < initialLines.length; i++) {
        let line = initialLines[i].trim();
        if (line.length === 0) continue;
        
        let linesToAdd = [];
        
        let splitPattern = /\s+(?=[A-ZĄĆĘŁŃÓŚŹŻ][^,]*?,)/g;
        let parts = line.split(splitPattern);
        
        if (parts.length > 1) {
          linesToAdd = parts.map(p => p.trim()).filter(p => p.length > 0);
        } else {
          let wordPattern = /\b([A-ZĄĆĘŁŃÓŚŹŻ][a-ząćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ\s()]+?)\s*,\s*([^A-ZĄĆĘŁŃÓŚŹŻ]*(?:\s+(?=[A-ZĄĆĘŁŃÓŚŹŻ])|$))/g;
          let matches = [];
          let match;
          let lastIndex = 0;
          
          while ((match = wordPattern.exec(line)) !== null) {
            if (match.index > lastIndex) {
              let before = line.substring(lastIndex, match.index).trim();
              if (before) {
                matches.push(before);
              }
            }
            let matchText = line.substring(match.index, match.index + match[0].length);
            let nextIndex = line.indexOf(' ', match.index + match[0].length);
            if (nextIndex > -1) {
              let nextChar = line.charAt(nextIndex + 1);
              if (nextChar && nextChar === nextChar.toUpperCase() && /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(nextChar)) {
                matches.push(matchText.trim());
                lastIndex = match.index + match[0].length;
              } else {
                let restOfLine = line.substring(match.index + match[0].length);
                let nextBigLetterMatch = restOfLine.match(/\s+([A-ZĄĆĘŁŃÓŚŹŻ][^,]*?,)/);
                if (nextBigLetterMatch) {
                  let endIndex = match.index + match[0].length + restOfLine.indexOf(nextBigLetterMatch[0]);
                  matches.push(line.substring(match.index, endIndex).trim());
                  lastIndex = endIndex;
                  wordPattern.lastIndex = lastIndex;
                } else {
                  matches.push(line.substring(match.index).trim());
                  lastIndex = line.length;
                  break;
                }
              }
            } else {
              matches.push(line.substring(match.index).trim());
              lastIndex = line.length;
              break;
            }
          }
          
          if (matches.length > 0) {
            linesToAdd = matches;
          } else {
            let simpleSplit = line.split(/\s+(?=[A-ZĄĆĘŁŃÓŚŹŻ])/);
            linesToAdd = simpleSplit.map(s => s.trim()).filter(s => s.length > 0);
            if (linesToAdd.length === 0) {
              linesToAdd = [line];
            }
          }
        }
        
        allLines = allLines.concat(linesToAdd);
      }
      
      contentDOM += `<div class="table">`

      if ( this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' ) {
        if ( !titleFlag ) {
          titleFlag = true;
          contentDOM += `<span class="table-line table-line--heading">`;
          if ( this.dataset.titleLabelLeft != '' ) {
            contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
          }
          if ( this.dataset.titleLabelRight != '' ) {
            contentDOM += `<span>${this.dataset.titleLabelRight}</span>`;
          }
          contentDOM += `</span>`;
        }
      }

      for ( let j = 0; j < allLines.length; j++ ) {
        let line = allLines[j].trim();
        
        if (line.length === 0 || line.replace(/\s/g, '').length === 0) {
          continue;
        }
        
        let isIndent = line.startsWith('-');
        if (isIndent) {
          line = line.substring(1).trim();
        }
        
        if (!isIndent && line.length > 0) {
          let firstChar = line.charAt(0);
          if (firstChar === firstChar.toLowerCase() && /[a-ząćęłńóśźż]/.test(firstChar)) {
            isIndent = true;
          }
        }
        
        let commaIndex = line.indexOf(',');
        let label = '';
        let value = '';
        
        if (commaIndex > -1) {
          label = line.substring(0, commaIndex).trim();
          value = line.substring(commaIndex + 1).trim();
        } else {
          let colonIndex = line.indexOf(':');
          if (colonIndex > -1) {
            label = line.substring(0, colonIndex).trim();
            value = line.substring(colonIndex + 1).trim();
          } else {
            let numberMatch = line.match(/^(.+?)\s+(\d)/);
            if (numberMatch && numberMatch[1].trim().length > 0) {
              label = numberMatch[1].trim();
              value = line.substring(numberMatch[1].length).trim();
            } else {
              label = line;
            }
          }
        }
        
        label = label.replace(/<[^>]*>/g, '').trim();
        value = value.replace(/<[^>]*>/g, '').trim();
        
        if (label || value) {
          contentDOM += `<span class="table-line ${isIndent ? 'table-line--indent' : ''}">`;
          if (label) {
            contentDOM += `<span>${label}</span>`;
          }
          if (value) {
            contentDOM += `<span>${value}</span>`;
          }
          contentDOM += `</span>`;
        }
      }

      contentDOM += `</div>`;
      
      this.innerHTML = contentDOM;

    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}
